import { useContext, useEffect, useState } from "react"
import { AuthContext } from "../contexts/AuthContext"
import * as userService from '../admin/services/userService';

import Swal from 'sweetalert2';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { CircleSpinnerOverlay } from "react-spinner-overlay";

export const EditParent = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const { user } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [initialUserData, setInitialUserData] = useState({})
    const [formData, setFormData] = useState({
        egn: '',
        name: '',
        phone: '',
        email: '',
    })
    const [enableEdit, setEnableEdit] = useState(false);

    document.title = `Моят профил`;

    useEffect(() => {
        setLoading(true);
        userService.getById(user.id)
            .then((data) => {
                setFormData(state => ({
                    ...state,
                    egn: data.egn,
                    name: data.name,
                    phone: data.phone,
                    email: data.email
                }))
                setInitialUserData(data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err)
                Swal.fire({
                    title: 'Възникна грешка',
                    text: 'Презаредете страницата',
                    icon: 'error',
                    confirmButtonText: 'ОК'
                })
                setLoading(false);
            })
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(state => ({
            ...state,
            [name]: value
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if (formData.name.length < 5) {
            Swal.fire({
                title: 'Възникна грешка',
                text: 'Трите имена трябва да бъдат поне 5 символа',
                icon: 'error',
                confirmButtonText: 'ОК'
            })

            return;
        } else if (formData.phone.length < 8) {
            Swal.fire({
                title: 'Възникна грешка',
                text: 'Телефонът трябва да бъдат поне 8 символа',
                icon: 'error',
                confirmButtonText: 'ОК'
            })

            return;
        } else if (!emailRegex.test(formData.email)) {
            Swal.fire({
                title: 'Възникна грешка',
                text: 'Невалиден имейл адрес',
                icon: 'error',
                confirmButtonText: 'ОК'
            })

            return;
        }

        setLoading(true);

        userService.editParent(user.id, formData)
            .then((data) => {
                if (data) {
                    setInitialUserData(data);
                }

                Swal.fire({
                    title: 'Редакцията е успешна',
                    text: 'Ако сте редактирали имейл адреса, ще трябва да го потвърдите отново, като влезете в новия имейл.',
                    icon: 'success',
                    confirmButtonText: 'ОК'
                })

                setEnableEdit(false)
                setLoading(false);
            })
            .catch((err) => {
                Swal.fire({
                    title: 'Възникна грешка',
                    text: err.message,
                    icon: 'error',
                    confirmButtonText: 'ОК'
                })
                setLoading(false);
            })
    }

    return (
        <div>
            <div>
                <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
                <div className="title_entr">Моят профил</div>

                <div className="fp_form d-flex justify-content-center">

                    <form className="form w-35 w-100-mob" id="login" method="post" action="login">

                        <div className="card d-flex p-3 w-100 gap-4">
                            <div className="input-group">
                                <div className="labels" id="basic-addon1">ЕГН</div>
                                <InputText
                                    name='egn'
                                    value={formData.egn}
                                    maxLength={10}
                                    className="w-100-mob w-100"
                                    disabled={true}
                                />
                            </div>

                            <div className="input-group ">
                                <div className="labels" id="basic-addon2">Три имена</div>
                                <InputText
                                    name='name'
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-100-mob w-100"
                                    disabled={!enableEdit}
                                />
                            </div>

                            <div className="input-group ">
                                <div className="labels" id="basic-addon1">Телефон 📞</div>
                                <InputText
                                    name='phone'
                                    value={formData.phone}
                                    onChange={handleChange}
                                    maxLength={20}
                                    className="w-100-mob w-100"
                                    disabled={!enableEdit}
                                />
                            </div>

                            <div className="input-group ">
                                <div className="labels" id="basic-addon2">Имейл 📧</div>
                                <InputText
                                    name='email'
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="w-100-mob w-100"
                                    disabled={!enableEdit}
                                    maxLength={255}
                                />
                            </div>


                        </div>


                        <div className="form-group">

                            <div className="d-flex justify-content-between">
                                {/*<button type="submit" id="" className="btn btn-info btn-cust" >Потвърди</button>*/}
                                {enableEdit
                                    ? <>
                                        <Button className="btn btn-success w-35" label="Потвърди" icon="pi pi-check" onClick={onSubmit} />
                                        <Button className="btn btn-danger w-35 " label="Откажи" icon="pi pi-times" onClick={(e) => { e.preventDefault(); setEnableEdit(false); setFormData(initialUserData) }} />
                                    </>
                                    : <Button className="btn btn-warning w-35 w-40-l w-100-mob" label="Редактирай" icon="pi pi-user-edit" onClick={(e) => { e.preventDefault(); setEnableEdit(true) }} />
                                }
                            </div>

                        </div>




                    </form>

                </div>

            </div>
        </div>
    )
}